import message from './_message'
import ui from './_ui'
import error from './_error'
import m from './_m'

export default {
  message: message,
  ui: ui,
  error: error,
  m: m
}